import { runDemo } from "../shared/demoRunner";
import { createGltfScene } from "./scene";

runDemo({
    createScene: createGltfScene,
});
